module.exports = __webpack_public_path__ + "img/download-gray.f0b63f44.svg";